import {
    AUTO_CHANGE_NAVIGATE_STAUTS,
    CHANGE_NAVIGATE,
    CHANGE_NAVIGATE_STAUTS,
    INIT_WEBSOCKET,
    LOAD_CURRENT_USER,
    LOAD_NAVIGATE_DATA,
    LOAD_SYSTEM_CONFIG,
    REFRESH_PAGE,
    SHRIN_MIN_LENGTH,
    SHRIN_NAVIGATE_STAUTS, SYSTEM_STATUS,
    UN_READ_MESSAGE_COUNT,
    UPDATE_NAVIGATE_DATA,
    UPDATE_NAVIGATE_LEVEL2_DATA
} from "../constants";
import {combineReducers} from "redux";
import zykReducer from "./zyk";
import storyReducer from "./story";
import projectReducer from './majorProjects'
import {applicationName} from "../utils";
import {setInfoToLocalStorage} from "../actions";

let navigateStatus = window.innerWidth >= SHRIN_MIN_LENGTH;//展开
let initSystemState = {
    initNavigateData: false,//未初始化导航数据，这里是避免每次点击都会去重新加载导航的数据
    navigateStatus: navigateStatus,//展开
    manualNavigateStatusTime: 0,//上一次手动改变导航状态的时间。这个主要解决二级导航是自动收缩，如果没有这个，在有二级导航的时候，就展不开导航
    currentUser: null,
    refersh: false,//是否刷新
    navigateLevel2Data: [],//2级导航数据
    navigateLevel2Title:""//2级导航标题
};

window.env = applicationName();

function systemReducer(state = initSystemState, action){
    switch(action.type){
        case LOAD_CURRENT_USER:
            let currentUser={...action.currentUser}
            if(action.currentUser.defaultInfo&&action.currentUser.defaultInfo.dept){
                currentUser.deptIds=[action.currentUser.defaultInfo.dept.id]
                currentUser.deptList=[action.currentUser.defaultInfo.dept];
                let roleList=currentUser.defaultInfo.roleList||[];
                let roleCodes=[];
                roleList.forEach(role=>{
                    roleCodes.push(role.roleCode)
                })
                currentUser.roleCodes=roleCodes;
                currentUser.roleList=roleList;
            }
            setInfoToLocalStorage("currentUser",currentUser);
            window.currentUser = currentUser;
            window.userAccount = action.currentUser.account;//兼容老版本非react开发的界面
            return {
                ...state,
                currentUser: action.currentUser,
            };
        case SHRIN_NAVIGATE_STAUTS:
            return {
                ...state,
                navigateStatus: false,
            };
        case CHANGE_NAVIGATE_STAUTS:
            return {
                ...state,
                manualNavigateStatusTime: new Date().getTime(),
                navigateStatus: !state.navigateStatus,
            };
        case AUTO_CHANGE_NAVIGATE_STAUTS:
            return {
                ...state,
                navigateStatus: !state.navigateStatus,
            };
        case CHANGE_NAVIGATE:
            return{
                ...state,
                menuId: action.menuId
            };
        case LOAD_NAVIGATE_DATA:
        case UPDATE_NAVIGATE_DATA:
            return{
                ...state,
                initNavigateData: true,//只要加载过了一次，就更新状态，这样就可以在所有执行加载（不是更新的地方）的地方进行限制
                navigateData: action.navigateData
            };
        case REFRESH_PAGE:
            return {
                ...state,
                refersh: action.refersh
            };
        case UPDATE_NAVIGATE_LEVEL2_DATA:
            return{
                ...state,
                navigateLevel2Title:action.navigateLevel2Title,
                navigateLevel2Data: action.navigateLevel2Data
            };
        case UN_READ_MESSAGE_COUNT:
            return{
                ...state,
                messageCount:action.messageCount,
            };
        case SYSTEM_STATUS:
            return {
                ...state,
                systemStatus:action.systemStatus
            };
        case LOAD_SYSTEM_CONFIG:
            return{
                ...state,
                config: {
                    data: action.config,
                    getConfigByKey: (key)=>{
                        let data = action.config;
                        for(let i = 0; data && i < data.length; i++){
                            let item = data[i];
                            if(key === item.configKey){
                                return item;
                            }
                        }
                        return {};
                    },
                    getValueByKey: (key, defaultValue='')=>{
                        let data = action.config;
                        for(let i = 0; data && i < data.length; i++){
                            let item = data[i];
                            if(key === item.configKey){
                                return item.configValue?item.configValue:defaultValue;
                            }
                        }
                        return defaultValue;
                    }
                }
            };
        default: return state;
    }
}

export default combineReducers({
    systemReducer, zykReducer, storyReducer,projectReducer
})